module.exports = __webpack_public_path__ + "static/media/unlink-notification.cf46ac02.svg";